import { render, staticRenderFns } from "./FormBeneficiosConcedente.vue?vue&type=template&id=8a30b4b0"
import script from "./FormBeneficiosConcedente.vue?vue&type=script&lang=js"
export * from "./FormBeneficiosConcedente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports